
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bnpc5", function(module, exports) {
$parcel$export(module.exports, "initialize", () => (parcelRequire("9n3E6")).initialize);

var $9n3E6 = parcelRequire("9n3E6");


});

parcelRegister("8DbIB", function(module, exports) {

var $gzdsP = parcelRequire("gzdsP");


var $9wGTI = parcelRequire("9wGTI");

const $904c12af9a85f522$export$bd0f03fe0cbdb301 = ()=>window.addEventListener('load', $904c12af9a85f522$export$53d88fe222065052);
const $904c12af9a85f522$export$53d88fe222065052 = ()=>{
    const contentArea = document.getElementById('full-height-container');
    if (!contentArea) return;
    new ResizeObserver($904c12af9a85f522$export$7a6ca3c267407ef3).observe(contentArea);
};
const $904c12af9a85f522$export$7a6ca3c267407ef3 = (entries)=>{
    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
    const uniqueKey = observableObject?.object?.uniqueKey;
    entries.forEach(({ target: { scrollHeight: scrollHeight, scrollWidth: scrollWidth } })=>{
        window.parent?.postMessage({
            type: 'contentSize',
            height: scrollHeight,
            width: scrollWidth,
            ...(0, $9wGTI.fg)('platform_deprecate_lp_cc_embed') ? {
                uniqueKey: uniqueKey
            } : {}
        }, '*');
    });
};
module.exports["subscribeToContentSize"] = $904c12af9a85f522$export$bd0f03fe0cbdb301;

});

parcelRegister("keSzP", function(module, exports) {

var $gzdsP = parcelRequire("gzdsP");


var $9wGTI = parcelRequire("9wGTI");

const $62cc436ef9dde75e$export$d09b8528f9c252ef = ()=>window.addEventListener('load', $62cc436ef9dde75e$export$55a50121f3b4ab25);
const $62cc436ef9dde75e$export$55a50121f3b4ab25 = ()=>{
    const targetElement = document.getElementById('full-height-container');
    if (!targetElement) return;
    // Create the IntersectionObserver
    // eslint-disable-next-line no-restricted-syntax
    new IntersectionObserver($62cc436ef9dde75e$export$efa641ccb49ef36a, {
        root: null,
        threshold: [
            0,
            1
        ]
    }).observe(targetElement);
};
const $62cc436ef9dde75e$export$efa641ccb49ef36a = (entries)=>{
    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
    const uniqueKey = observableObject?.object?.uniqueKey;
    entries.forEach((entry)=>{
        const visibleHeight = entry.intersectionRect.height;
        window.parent.postMessage({
            type: 'embeddedConfluenceVisibleHeight',
            value: visibleHeight,
            ...(0, $9wGTI.fg)('platform_deprecate_lp_cc_embed') ? {
                uniqueKey: uniqueKey
            } : {}
        }, '*');
    });
};
module.exports["subscribeToVisibleHeight"] = $62cc436ef9dde75e$export$d09b8528f9c252ef;

});

parcelRegister("6SI5I", function(module, exports) {

let $5029fccef7fda24a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5029fccef7fda24a$var$load("6h5a5"),
    $5029fccef7fda24a$var$load("1R7So")
]).then(()=>parcelRequire('20DN7'));

});

parcelRegister("hNp2K", function(module, exports) {

let $cf4a705f788d154b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf4a705f788d154b$var$load("6h5a5"),
    $cf4a705f788d154b$var$load("D76lz")
]).then(()=>parcelRequire('2p6LO'));

});

parcelRegister("9n3E6", function(module, exports) {
/* eslint-disable-next-line no-restricted-imports */ 
var $4icDV = parcelRequire("4icDV");


var $fGzMp = parcelRequire("fGzMp");


var $8DbIB = parcelRequire("8DbIB");


var $gzdsP = parcelRequire("gzdsP");


var $14DR2 = parcelRequire("14DR2");


var $2XqLN = parcelRequire("2XqLN");





var $1NBp8 = parcelRequire("1NBp8");

const $bcd573e5415f0072$var$REQUIRED_EMBEDDED_CONFLUENCE_HEADER_KEYS = [
    'contentId',
    'parentProduct',
    'spaceKey'
];
// Although parentProductContentContainerId is optional, it is still required for unlicensed access.
const $bcd573e5415f0072$var$OPTIONAL_EMBEDDED_CONFLUENCE_HEADER_KEYS = [
    'parentProductContentContainerId',
    'parentProductContentId'
];
const $bcd573e5415f0072$export$4de094b68e927f31 = 'x-atl-embeddablepage-entityids';
const $bcd573e5415f0072$export$dd5df62f358a73a5 = (location)=>{
    if (!location) location = window.location;
    const url = location?.href ?? '';
    return $bcd573e5415f0072$var$getEmbeddedConfluenceHeaderFromURL(url);
};
const $bcd573e5415f0072$var$getEmbeddedConfluenceHeaderFromURL = (0, $2XqLN.default)((url)=>{
    const match = (0, $1NBp8.VIEW_PAGE).match(url) || (0, $1NBp8.EDIT_PAGE_EMBED).match(url) || (0, $1NBp8.WHITEBOARD_BOARD).match(url);
    if (!match) return;
    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
    const headerValue = [
        ...$bcd573e5415f0072$var$REQUIRED_EMBEDDED_CONFLUENCE_HEADER_KEYS,
        ...$bcd573e5415f0072$var$OPTIONAL_EMBEDDED_CONFLUENCE_HEADER_KEYS
    ].reduce((value, key)=>{
        value[key] = observableObject?.object?.[key] || match.params?.[key] || match.query?.[key];
        return value;
    }, {});
    const isValidHeader = $bcd573e5415f0072$var$REQUIRED_EMBEDDED_CONFLUENCE_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$bcd573e5415f0072$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
});


// We only want to add custom headers to confluence apis since adding to external api might result CORS issue because of security.
const $2ff6a149001f9f76$var$ALLOWED_API_PATHS = /\/wiki\/|\/cgraphql|\/gateway\/api\//;
function $2ff6a149001f9f76$var$shouldAddEmbeddedConfluenceHeader(url) {
    // We add the shimUrl to the allowedAPIPath so that the custom headers are passed to the redirected call. Without the custom headers, the backend won't be able to authenticate for JSM customer accounts.
    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
    const shimUrl = observableObject?.object?.navigationPolicy?.shimUrl;
    const allowedAPIPath = shimUrl ? RegExp(`${$2ff6a149001f9f76$var$ALLOWED_API_PATHS.source}|${shimUrl}`) : $2ff6a149001f9f76$var$ALLOWED_API_PATHS;
    return url?.match(allowedAPIPath);
}
const $2ff6a149001f9f76$export$1d0632a8f7981875 = ()=>{
    if ((0, $bcd573e5415f0072$export$dd5df62f358a73a5)()) {
        $2ff6a149001f9f76$var$interceptFetch();
        $2ff6a149001f9f76$var$interceptXMLHttpRequest();
    }
};
const $2ff6a149001f9f76$var$interceptFetch = ()=>{
    /* eslint-disable no-restricted-properties */ const { fetch: originalFetch } = window;
    if (!window.fetch['__INTERCEPTED__']) {
        // eslint-disable-next-line no-restricted-properties
        window.fetch = (resource, requestInit)=>{
            const url = typeof resource === 'string' ? resource : resource.url;
            if ($2ff6a149001f9f76$var$shouldAddEmbeddedConfluenceHeader(url)) {
                const header = (0, $bcd573e5415f0072$export$dd5df62f358a73a5)();
                if (header) {
                    // When resource is a Request object, adding headers in requestInit will override headers that is set in the Request obj if there's one.
                    // So we need to add headers at the correct place
                    let headers = requestInit?.headers || resource['headers'];
                    if (!headers) {
                        requestInit = requestInit || {};
                        requestInit.headers = requestInit.headers || {};
                        headers = requestInit.headers;
                    }
                    (0, $14DR2.appendHeader)(headers, (0, $bcd573e5415f0072$export$4de094b68e927f31), header[0, $bcd573e5415f0072$export$4de094b68e927f31]);
                }
            }
            return originalFetch(resource, requestInit);
        };
        window.fetch['__INTERCEPTED__'] = true;
    }
/* eslint-enable no-restricted-properties */ };
const $2ff6a149001f9f76$var$interceptXMLHttpRequest = ()=>{
    // We need to monkey patch XMLHttpRequest.open because we are not able to extract url from XMLHttpRequest object
    if (!XMLHttpRequest.prototype.open['__INTERCEPTED__']) {
        const originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function(...args) {
            this['__URL__'] = args[/* url */ 1];
            // @ts-ignore
            return originalOpen.apply(this, args);
        };
        XMLHttpRequest.prototype.open['__INTERCEPTED__'] = true;
    }
    if (!XMLHttpRequest.prototype.send['__INTERCEPTED__']) {
        const originalSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function(body) {
            if ($2ff6a149001f9f76$var$shouldAddEmbeddedConfluenceHeader(this['__URL__'])) {
                const header = (0, $bcd573e5415f0072$export$dd5df62f358a73a5)()?.[0, $bcd573e5415f0072$export$4de094b68e927f31];
                header && !this['isEmbeddedConfluenceHeaderSet'] && this.setRequestHeader((0, $bcd573e5415f0072$export$4de094b68e927f31), header);
            }
            originalSend.call(this, body);
        };
        XMLHttpRequest.prototype.send['__INTERCEPTED__'] = true;
    }
    // Avoid adding duplicate embedded Confluence header value
    if (!XMLHttpRequest.prototype.setRequestHeader['__INTERCEPTED__']) {
        const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;
        XMLHttpRequest.prototype.setRequestHeader = function(key, value) {
            if (key.toLowerCase() === (0, $bcd573e5415f0072$export$4de094b68e927f31)) this['isEmbeddedConfluenceHeaderSet'] = true;
            originalSetRequestHeader.call(this, key, value);
        };
        XMLHttpRequest.prototype.setRequestHeader['__INTERCEPTED__'] = true;
    }
};



var $keSzP = parcelRequire("keSzP");



function $79ea9887b628aa3a$export$2a47f398eeff8b01() {
    (0, $2ff6a149001f9f76$export$1d0632a8f7981875)();
    (0, $8DbIB.subscribeToContentSize)();
    (0, $keSzP.subscribeToVisibleHeight)();
    window.parent.postMessage({
        type: (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED),
        payload: {
            timestamp: Date.now()
        }
    }, '*');
    window.addEventListener('unload', ()=>{
        // signal to EP parent that it is safe to run onUnload handler that may interfere with CCFE
        window.parent?.postMessage({
            type: 'windowUnload'
        }, '*');
    });
    return Promise.all([
        (parcelRequire("6SI5I")),
        (parcelRequire("hNp2K"))
    ]).then(([{ subscribeCrossDomainCommunication: subscribeCrossDomainCommunication }, { crossDomainExperienceForwarding: crossDomainExperienceForwarding }])=>{
        subscribeCrossDomainCommunication();
        crossDomainExperienceForwarding((0, $fGzMp.getExperienceTracker)());
    });
}
module.exports["initialize"] = $79ea9887b628aa3a$export$2a47f398eeff8b01;

});


//# sourceMappingURL=initialize.6e85072b.js.map
